var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isStep(_vm.stepNumber))?_vm._t(`${_vm.stepName}`):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }